import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import Grow from '@mui/material/Grow';
import Slide from '@mui/material/Slide';
import { useSnackbar } from 'notistack';
import CostSection from '../CostSection';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import Toolbar from '@mui/material/Toolbar';
import { Box, Divider } from '@mui/material';
import DefectSection from '../DefectSection';
import Checkbox from '@mui/material/Checkbox';
import CostSuggestion from '../CostSuggestion';
import { resetSliceState } from '../defectSlice';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import DefectFormFooter from '../DefectFormFooter';
import DefectSuggestion from '../DefectSuggestion';
import { useDispatch, useSelector } from 'react-redux';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import SourceDataRoomSection from '../SourceDataRoomSection';
import FormControlLabel from '@mui/material/FormControlLabel';
import { saveElementAndDefect } from '../../../api/defectApi';
import ElementSection from '../element-section/ElementSection';
import { getDialogBoxHeader, getLabel } from '../../../../../utils/helper';
import {
  createDefectDto,
  createElementDto,
  createMeasureDto,
  formData,
  createFreshFormData,
  validationSchema,
} from '../defectHelper';
import EnhancedDefectForm from './EnhancedDefectForm';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CreateDefect(props) {
  const [createAnother, setcreateAnother] = useState(false);
  const [useNewDefectForm, setUseNewDefectForm] = useState(true); // Toggle state for new/old form - default to NEW FORM
  const containerRef = React.useRef(null);
  const scope = useSelector((state) => state.container.scope);
  const openAsset = useSelector((state) => state.openAsset);
  const state = useSelector((state) => state.tddDefectSection);
  const tddState = useSelector((state) => state.tddKeyFinding);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const formRef = useRef();

  // 🆕 CLIENT-SIDE BUFFERING: Track buffered images and upload function
  const [imageUploadData, setImageUploadData] = useState({
    bufferedImages: [],
    hasBufferedImages: false,
    uploadFunction: null
  });
  const [isUploadingImages, setIsUploadingImages] = useState(false);

  // Dynamic form data to ensure fresh state on each render
  const [intialFormData, setIntialFormData] = useState(() => createFreshFormData());

  const [apiCallCondition, setApiCallCondition] = useState({
    projectIdent: '',
    ident: '',
    elementName: '',
    defectType: '',
  });

  // Reset form state when dialog opens or subCategory changes
  useEffect(() => {
    if (props.open && props.subCategory) {
      // Reset to fresh form data
      setIntialFormData(createFreshFormData());
      // Keep NEW FORM as default (don't reset to false)
      setUseNewDefectForm(true);
      // Reset any cached API conditions
      setApiCallCondition({
        projectIdent: '',
        ident: '',
        elementName: '',
        defectType: '',
      });
      // Clear any previous slice state
      dispatch(resetSliceState());
    }
  }, [props.open, props.subCategory, dispatch]);

  // Create stable row object for DefectImageUploader to prevent infinite API calls
  const stableRowForDefectImages = React.useMemo(() => ({
    defectIdent: null, // Always null for new defects
    trade: { value: '' },
    type: 'defect_row',
    deleted: false,
    imageCount: 0
  }), []); // Empty dependency array since this is for new defects

  useEffect(() => {
    if (state.saveDefect.type === 'SUCCESS') {
      // 🆕 CLIENT-SIDE BUFFERING: Upload buffered images after defect creation
      const handleSuccessWithImages = async () => {
        const defectData = state.saveDefect.data;
        
        // Check if we have buffered images to upload
        if (imageUploadData.hasBufferedImages && imageUploadData.uploadFunction) {
          try {
            // Extract defectIdent from response
            const defectIdent = defectData?.defectDto?.defectIdent || 
                               defectData?.defectIdent ||
                               defectData?.ident;
            
            if (defectIdent) {
              setIsUploadingImages(true);
              
              // Calculate total images (bufferedImages + uploaderFiles)
              const totalImageCount = (imageUploadData.bufferedImages?.length || 0) + 
                                     (imageUploadData.uploaderFiles?.length || 0);
              
              enqueueSnackbar(`Uploading ${totalImageCount} buffered image(s)...`, { 
                variant: 'info',
                autoHideDuration: 2000
              });
              
              // Upload buffered images with the new defectIdent
              const result = await imageUploadData.uploadFunction(defectIdent, scope.projectIdent);
              
              if (result.success) {
                enqueueSnackbar(`Successfully uploaded ${result.count} image(s)!`, { 
                  variant: 'success',
                  autoHideDuration: 3000
                });
              } else {
                enqueueSnackbar(`Image upload failed: ${result.error}`, { 
                  variant: 'error',
                  autoHideDuration: 4000
                });
              }
            }
          } catch (error) {
            enqueueSnackbar('Failed to upload images after defect creation', { 
              variant: 'error',
              autoHideDuration: 4000
            });
          } finally {
            setIsUploadingImages(false);
          }
        }
        
        // Show success messages
        state.saveDefect.messages.forEach((element) => {
          enqueueSnackbar(element, {
            variant: 'success',
            autoHideDuration: 2000,
          });
        });
        
        // Close dialog or reset form
        if (createAnother === false) {
          if (props.needGridRefresh && typeof props.needGridRefresh === 'function') {
            props.needGridRefresh(true);
          }
          props.onClose();
        } else {
          formRef.current.resetForm();
        }
        dispatch(resetSliceState());
      };
      
      handleSuccessWithImages();
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.saveDefect.type]);

    // Enhanced form toggle handler with state cleanup
  const handleFormToggle = useCallback((checked) => {
    setUseNewDefectForm(checked);
    if (formRef.current) {
      // Reset form when toggling
      formRef.current.resetForm();
    }
  }, []);

  // 🆕 Callback to receive buffered images from DefectImageUploaderWithGenerate
  const handleImageUploadData = useCallback((data) => {
    setImageUploadData({
      bufferedImages: data.bufferedImages || [],
      hasBufferedImages: data.hasBufferedImages || false,
      uploadFunction: data.uploadBufferedImages
    });
  }, []);

    const onSave = (values) => {
    // Determine if we should create another defect after saving
    if (!scope?.projectIdent) {
      enqueueSnackbar('Error: Missing project identifier', { variant: 'error' });
      return;
    }
    
    if (!openAsset?.ident) {
      enqueueSnackbar('Error: Missing asset identifier', { variant: 'error' });
      return;
    }
    
    // Validate form data
    const requiredFields = ['defectDescription', 'measureDescription', 'riskType', 'defectType', 'priority'];
    const missingFields = requiredFields.filter(field => !values[field]);
    
    if (missingFields.length > 0) {
      enqueueSnackbar(`Error: Missing required fields: ${missingFields.join(', ')}`, { variant: 'error' });
      return;
    }
    
    // Validate element data (different validation for old vs new form)
    if (!useNewDefectForm) {
      // Old form validation
      if (!values.isElementOther && !values.elementType) {
        enqueueSnackbar('Error: Please select an element type', { variant: 'error' });
        return;
      }
      if (values.isElementOther && (!values.customElement?.value && !values.customElement?.title)) {
        enqueueSnackbar('Error: Please provide custom element name', { variant: 'error' });
        return;
      }
    } else {
      // New form validation
      if (!values.elementType && !values.elementName) {
        enqueueSnackbar('Error: Please select or provide element information', { variant: 'error' });
        return;
      }
      // Additional validation for "Others" with custom element name
      if (values.isElementOther && (!values.customElement?.value && !values.customElement?.title)) {
        enqueueSnackbar('Error: Please provide a custom element name for "Others"', { variant: 'error' });
        return;
      }
    }
    
    let element = createElementDto(values);
    const measureDto = createMeasureDto(values);
    let defect = createDefectDto(values);

    const assetIdent = openAsset.ident;
    const saveDefect = {
      projectIdent: scope.projectIdent,
      elementDto: { ...element, assetIdent: openAsset.ident },
      defectDto: {
        ...defect,
        measureDtoList: [measureDto],
        assetIdent: assetIdent,
      },
    };
    
    try {
      dispatch(saveElementAndDefect(saveDefect));
    } catch (error) {
      enqueueSnackbar('Error saving defect: ' + error.message, { variant: 'error' });
    }
  };

  return (
    <>
      {!!props.subCategory && (
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={props.open}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              // Clean up state when closing (keep NEW FORM as default for next open)
              setUseNewDefectForm(true);
              setIntialFormData(createFreshFormData());
              dispatch(resetSliceState());
              props.onClose();
            }
          }}
          TransitionComponent={Transition}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              height: 'auto',
              overflow: 'hidden'
            }
          }}
        >
          <Formik
            enableReinitialize
            initialValues={intialFormData}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              // No transformation needed - EnhancedDefectForm already sets customElement correctly
              // Just pass values directly to onSave
              onSave(values);
            }}
            innerRef={formRef}
          >
            {({
              values,
              setFieldValue,
              errors,
              touched,
              handleChange,
              isSubmitting,
              resetForm,
              isValid,
              validateForm,
            }) => (
              <>
                <AppBar
                  style={{ position: 'relative', height: 40 }}
                  className="appBar"
                >
                  <Toolbar
                    style={{ minheight: 40 }}
                    className="dialog-toolbar d-flex align-items-center p-1"
                  >
                    <Typography variant="h6" style={{ flex: 1, marginLeft: 5 }}>
                      {getDialogBoxHeader('_Defect')}
                    </Typography>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.costDefect}
                            style={{
                              color: values.costDefect ? '#254a9a' : '#ffffff',
                            }}
                            onChange={(e) =>
                              setFieldValue('costDefect', e.target.checked)
                            }
                          />
                        }
                        label={
                          <Typography
                            variant="button"
                            style={{
                              fontWeight: 'bold',
                              textTransform: 'uppercase',
                              marginLeft: 4,
                            }}
                          >
                            {getLabel('_Cost-Defect')}
                          </Typography>
                        }
                        labelPlacement="end"
                      />
                    </Box>
                    <Divider
                      orientation="vertical"
                      style={{
                        width: 4,
                        margin: '10px 10px',
                        backgroundColor: '#ffffff',
                      }}
                      flexItem
                    />
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={useNewDefectForm}
                            style={{
                              color: useNewDefectForm ? '#254a9a' : '#ffffff',
                            }}
                            onChange={(e) =>
                              handleFormToggle(e.target.checked)
                            }
                          />
                        }
                        label={
                          <Typography
                            variant="button"
                            style={{
                              fontWeight: 'bold',
                              textTransform: 'uppercase',
                              marginLeft: 4,
                            }}
                          >
                            New Form
                          </Typography>
                        }
                        labelPlacement="end"
                      />
                    </Box>
                    <Divider
                      orientation="vertical"
                      style={{
                        width: 4,
                        margin: '10px 10px',
                        backgroundColor: '#ffffff',
                      }}
                      flexItem
                    />
                    <div style={{ marginLeft: 'auto' }}>
                      <IconButton
                        edge="start"
                        color="inherit"
                        onClick={props.onClose}
                        aria-label="close"
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  </Toolbar>
                </AppBar>
                <DialogContent
                  dividers
                  className={'custom-scrollBar'}
                  style={{ 
                    padding: '0px 5px',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    maxHeight: '70vh'
                  }}
                >
                  <Form>
                    {!useNewDefectForm ? (
                      // Original/Old Form
                      <>
                        <Box className={'d-flex align-items-start flex-wrap'}>
                          <ElementSection
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            resetForm={(e) => resetForm()}
                            subCategory={props.subCategory}
                          />
                          <DefectSection
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                          />
                        </Box>

                        <>
                          <Box style={{ width: '100%' }}>
                            <DefectSuggestion
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                            />
                          </Box>

                          <Grow
                            direction="up"
                            container={containerRef.current}
                            in={values.costDefect}
                            style={{ transformOrigin: '0 0 0' }}
                            {...(values.costDefect ? { timeout: 1000 } : {})}
                            mountOnEnter
                            unmountOnExit
                          >
                            <Box style={{ marginTop: 10, marginLeft: 0 }}>
                              <Box
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  width: '100%',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <CostSuggestion
                                  values={values}
                                  setFieldValue={setFieldValue}
                                  errors={errors}
                                  touched={touched}
                                  handleChange={handleChange}
                                />
                                <CostSection
                                  values={values}
                                  setFieldValue={setFieldValue}
                                  errors={errors}
                                  touched={touched}
                                  handleChange={handleChange}
                                  useModernPriorityInput={useNewDefectForm}
                                />
                              </Box>
                            </Box>
                          </Grow>
                          
                          <SourceDataRoomSection
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                          />
                        </>
                      </>
                    ) : (
                      // New Enhanced Defect Form
                      <EnhancedDefectForm 
                        values={values}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        subCategory={props.subCategory}
                        onImageUploadData={handleImageUploadData}
                      />
                    )}
                  </Form>
                </DialogContent>
              </>
            )}
          </Formik>
          <DialogActions>
            <DefectFormFooter
              createAnother={createAnother}
              displayCreateAnother={!useNewDefectForm}
              onClose={props.onClose}
              onSelect={(val) => setcreateAnother(val)}
              handleSubmit={(e) => {
                return formRef.current.handleSubmit();
              }}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}

CreateDefect.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  subCategory: PropTypes.object,
  onUpdate: PropTypes.func,
  needGridRefresh: PropTypes.func, // Optional callback to refresh parent grid
};

export default CreateDefect;
